import React from 'react';
import {Popup, Explanation_text} from '../../../../../../../components';
import Typography from '@material-ui/core/Typography';

export default function Contact_delete_popup(props){
  let name=props.contact.first_name; if(props.contact.last_name!=undefined){name=name+props.contact.last_name;}
  let prl_status='none';
  if(props.contact.workspace_default_special_services!=null){
    for(let x of props.contact.workspace_default_special_services){
      if(x.workspace_default_special_service_id==1){
        if(x.completed_date!=undefined && prl_status=='none'){prl_status='completed';}
        else{prl_status='pending';}
      }
  }}
  return(
    <Popup always_open title='prospect_contact_delete_popup_title' accept_button={(prl_status=='pending')?'Ok':'Delete'} handleClose={props.handleClose} accept_button_click={(prl_status=='pending')?props.handleClose:props.onDelete} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}>{
          (prl_status=='pending')?'Contacts awaiting JumpStart scoring can not be deleted.'
          :(prl_status=='completed')?'Warning: This contact has been scored. Deleting this contact means we will no longer be able to deduplicate for future JumpStart scorings.'
          :<Explanation_text inline text='prospect_contact_delete_popup_warning_text' placeholders={{name:name}}/>}</Typography></div>
      </div>
    }/>
  )
}
